interface SystemColors {
  error: string;
  primary: string;
  secondary: string;
  tertiary: string;
  accent: string;
  background: string;
}

const Colors: SystemColors = {
  error: "error",
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
  accent: "accent",
  background: "background",
};

export default Colors;
